<template>
  <a-card>
    <!-- 顶部筛选区（用户基础信息，昵称/姓名/手机号不可编辑） -->
    <a-form layout="inline" class="table-page-search-wrapper" style="margin-bottom: 16px">
      <a-row :gutter="48">
        <a-col :md="6" :sm="24">
          <a-form-item :label="$t('昵称')">
            <a-input :value="userInfo.nickName" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item :label="$t('姓名')">
            <a-input :value="userInfo.realName" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item :label="$t('手机号')">
            <a-input :value="userInfo.mobile" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item :label="$t('会员等级')">
            <a-input :value="userInfo.levelName" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item :label="$t('国家')">
            <a-input :value="userInfo.country" disabled />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <span class="table-page-search-submitButtons">
            <a-button type="primary" @click="getList"><a-icon type="search" />{{$t('查询')}}</a-button>
            <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: '160%' }"
    >
      <span slot="type" slot-scope="text, record">
        {{ record.typeName || text }}
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="updateTime" slot-scope="text, record">
        {{ parseTime(record.updateTime) }}
      </span>
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { withdrawalAccountPageUserDetail } from '@/api/biz/userDetail'
import { getUser } from '@/api/biz/user'

export default {
  name: 'WithdrawalAccountTable',
  mixins: [tableMixin],
  props: {
    userId: undefined
  },
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      loading: false,
      total: 0,
      userInfo: {
        nickName: undefined,
        realName: undefined,
        mobile: undefined,
        levelName: undefined,
        country: undefined
      },
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户昵称'),
          dataIndex: 'userNickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('账户类型'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('持卡人名称'),
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('银行名称'),
          dataIndex: 'bankName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('银行卡号'),
          dataIndex: 'bankCardNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('开户行'),
          dataIndex: 'openBankName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Routing Number',
          dataIndex: 'routingNumber',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Swift Code',
          dataIndex: 'swiftCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('更新时间'),
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created () {
    this.fetchUser()
    this.getList()
  },
  computed: {
    ...mapGetters(['tableBordered'])
  },
  watch: {
    userId (newVal) {
      this.fetchUser()
      this.getList()
    }
  },
  methods: {
    getTotal (total) {
      return this.$t('共') + total + this.$t('条')
    },
    fetchUser () {
      if (!this.userId) {
        return
      }
      getUser({ id: this.userId }).then(res => {
        const u = res.data || {}
        this.userInfo = {
          nickName: u.nickName,
          realName: u.realName,
          mobile: u.mobile,
          levelName: u.levelName,
          country: u.country
        }
      })
    },
    getList () {
      if (!this.userId) {
        return
      }
      this.loading = true
      this.queryParam.id = this.userId
      withdrawalAccountPageUserDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    resetQuery () {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = 10
      this.getList()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
